// Women's Categories Configuration
// This file centralizes all women's category definitions for the admin panel

export interface WomenCategoryGroup {
  name: string;
  subcategories: string[];
}

// Women's Categories with "womens" as the main category
export const womenCategories: WomenCategoryGroup[] = [
  {
    name: 'womens',
    subcategories: [
      // Footwear Categories
      'womens-slides',
      'womens-sneakers',
      'womens-boots',
      'high-heels',
      // Tops Categories
      'womens-t-shirts',
      'womens-sweaters',
      'womens-blouses',
      // Outerwear Categories
      'womens-jackets',
      'womens-coats',
      // Bottoms Categories
      'womens-jeans',
      'womens-shorts',
      'womens-skirts',
      'swimwear',
      // Accessories Categories
      'womens-handbags',
      'womens-jewelry',
      // Parent Categories (for organization)
      'womens-footwear',
      'womens-tops',
      'womens-outerwear',
      'womens-bottoms',
      'womens-accessories'
    ]
  }
];

// Flattened list of all women's categories for easy access
export const allWomenCategories = [
  // Main category
  'womens',
  // All subcategories
  ...womenCategories[0].subcategories
];

// Footwear specific categories (for women_shoes table)
export const womenFootwearCategories = [
  'womens-slides',
  'womens-sneakers',
  'womens-boots',
  'high-heels'
];

// Clothing specific categories (for women_clothing table)
export const womenClothingCategories = [
  'womens-t-shirts',
  'womens-sweaters',
  'womens-blouses',
  'womens-jackets',
  'womens-coats',
  'womens-jeans',
  'womens-shorts',
  'womens-skirts',
  'swimwear',
  'womens-handbags',
  'womens-jewelry',
  'womens-tops',
  'womens-outerwear',
  'womens-bottoms',
  'womens-accessories'
];

// Helper function to get parent category for a subcategory
export const getParentCategory = (subcategory: string): string | null => {
  if (womenCategories[0].subcategories.includes(subcategory)) {
    return 'womens';
  }
  return null;
};

// Helper function to get all subcategories for the main category
export const getSubcategories = (parentCategory: string): string[] => {
  if (parentCategory === 'womens') {
    return womenCategories[0].subcategories;
  }
  return [];
};

// Helper function to check if a category is the main category
export const isParentCategory = (category: string): boolean => {
  return category === 'womens';
};

// Helper function to check if a category is a subcategory
export const isSubcategory = (category: string): boolean => {
  return womenCategories[0].subcategories.includes(category);
};

// Display names for categories (for UI)
export const categoryDisplayNames: Record<string, string> = {
  // Main category
  'womens': "Women's",
  
  // Footwear subcategories
  'womens-slides': "Women's Slides",
  'womens-sneakers': "Women's Sneakers",
  'womens-boots': "Women's Boots", 
  'high-heels': "High Heels",
  
  // Tops subcategories
  'womens-t-shirts': "Women's T-Shirts",
  'womens-sweaters': "Women's Sweaters",
  'womens-blouses': "Women's Blouses",
  
  // Outerwear subcategories
  'womens-jackets': "Women's Jackets",
  'womens-coats': "Women's Coats",
  
  // Bottoms subcategories
  'womens-jeans': "Women's Jeans",
  'womens-shorts': "Women's Shorts", 
  'womens-skirts': "Women's Skirts",
  'swimwear': "Swimwear",
  
  // Accessories subcategories
  'womens-handbags': "Women's Handbags",
  'womens-jewelry': "Women's Jewelry",
  
  // Parent Categories (for organization)
  'womens-footwear': "Women's Footwear",
  'womens-tops': "Women's Tops", 
  'womens-outerwear': "Women's Outerwear",
  'womens-bottoms': "Women's Bottoms",
  'womens-accessories': "Women's Accessories"
};

// Helper function to get display name for a category
export const getCategoryDisplayName = (category: string): string => {
  return categoryDisplayNames[category] || category;
}; 